import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const SchlSearchList = (props) => {
    const { schlData, clickSchlCds, toggle, myInitInfo, isPathName } = props;

    const history = useHistory();
    const mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);

    const gotoSetTextbookScreen = (schlCd) => {
        history.push(
            "/mypage/myAatb?gradCd=" +
                String(myInitInfo.gradCd) +
                "&schlCd=" +
                schlCd +
                "&mmbrSeq=" +
                mmbrSeq +
                (props.from === "POPUP" ? "&from=POPUP" : ""),
        );
    };

    return (
        <li>
            <h4>{schlData.SCHL_NM}</h4>
            <p>{schlData.SCHL_ADDR}</p>
            <button
                onClick={(e) => {
                    e.preventDefault();
                    clickSchlCds(schlData.STD_SCHL_CD, schlData.SCHL_NM);
                    toggle();
                    isPathName.includes("/mypage/myInfo") && gotoSetTextbookScreen(schlData.STD_SCHL_CD);
                }}
            >
                확인
            </button>
        </li>
    );
};

export default SchlSearchList;
